export const SIZE_PAGE_CONTROL_PANEL = 15;
export const SIZE_PAGE_COMMUNICATION = 25;
